import { ExpertisePoint } from './expertise-point.types';

export enum UserGroup {
  All = 1000,
  OccoExpertise = 1,
  AutoKaleExpertise = 2,
}

export const UserGroupLabel = new Map<number, string>([
  [UserGroup.All, 'Hepsi'],
  [UserGroup.OccoExpertise, 'OCCO Ekspertiz'],
  [UserGroup.AutoKaleExpertise, 'Auto Kale Ekspertiz'],
]);

export interface User {
  id: number;

  email: string;

  name: string;

  surname: string;

  active: boolean;

  expertisePointId: number;

  isSuperAdmin: boolean;

  isAdmin: boolean;

  userGroup: UserGroup;

  expertisePoint: ExpertisePoint;
}

export interface RegisterUserRequest {
  name: string;
  surname: string;
  email: string;
  isAdmin: boolean;
  password: string;
  userGroup: number;
  expertisePointId?: number;
}

export interface UpdateUserRequest {
  id: number;
  name: string;
  surname: string;
  email: string;
  password?: string;
  isAdmin: boolean;
  userGroup: number;
}
